import React from 'react'
// c:\xampp\htdocs\miners-market-main\components\SubscribePrompt.js

export default function SubscribePrompt({ onSubscribe, onDismiss }) {
    const [isClosing, setIsClosing] = React.useState(false);

    const handleDismiss = () => {
        setIsClosing(true);
        setTimeout(onDismiss, 300);
    };

    const handleSubscribe = () => {
        setIsClosing(true);
        setTimeout(onSubscribe, 300);
    };

    return (
        <div className={`fixed bottom-4 left-1/2 transform -translate-x-1/2 md:top-4 md:bottom-auto md:left-auto md:right-4 md:transform-none w-auto md:w-full max-w-sm p-4 bg-white rounded-lg shadow-lg border border-gray-200 transition-all duration-300 z-50 ${isClosing ? 'opacity-0 translate-y-4' : 'opacity-100 translate-y-0'}`}>
            <div className="flex items-start">
                <div className="flex-shrink-0">
                    <svg className="h-6 w-6 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
                    </svg>
                </div>
                <div className="ml-3 w-0 flex-1">
                    <p className="text-sm font-medium text-gray-900">Stay Updated</p>
                    <p className="mt-1 text-sm text-gray-500">Enable notifications to receive important updates and offers.</p>
                    <div className="mt-4 flex">
                        <button
                            onClick={handleSubscribe}
                            className="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                        >
                            Enable
                        </button>
                        <button
                            onClick={handleDismiss}
                            className="ml-3 inline-flex items-center px-3 py-2 border border-gray-300 text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                        >
                            Later
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
